import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_garden_outdoor_decor: FaireCategoryEntity = {
  token: "cat_garden-outdoor-decor",
  type: "category",
  name: "Outdoor decor",
  level: 3,
  parentToken: "cat_home-decor-garden",
  href: "/category/home-decor/garden-outdoor/outdoor-decor",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
